var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { createClient, schemaToFields, getUniqueActions, defaultFlags } from "@glideapps/custom-component-client";
import { log } from "./util.js";
const promptDebounceDelay = 1500;
import { CustomComponentView } from "./CustomComponentView.js";
import { EmptyPlaceholder } from "./EmptyPlaceholder.js";
// This component wraps the custom component view with the ability to use
// the client and generate a component from a simple prompt
export function CustomComponent(props) {
    const { prompt, generator, schema = [], actions = [], endpoint, setRunning: setRunningExternal, setResult: setResultExternal, instructions, flags } = props;
    const [component, setComponent] = useState();
    const [isRunning, setRunning] = useState(false);
    const startedGeneration = useRef(0);
    useEffect(() => {
        if (component === undefined)
            return;
        setResultExternal === null || setResultExternal === void 0 ? void 0 : setResultExternal(component);
    }, [component, setResultExternal]);
    useEffect(() => {
        setRunningExternal === null || setRunningExternal === void 0 ? void 0 : setRunningExternal(isRunning);
    }, [isRunning, setRunningExternal]);
    const client = useMemo(() => createClient({ endpoint }), [endpoint]);
    const generate = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        const payload = {
            message: prompt,
            generator,
            fields: schema,
            actions,
            instructions,
            previous: undefined,
            environment: {
                fields: schemaToFields(schema), // TODO: remove mapping when add id's to schema
                actions: getUniqueActions(actions)
            },
            flags: Object.assign(Object.assign({}, defaultFlags), flags)
        };
        const serial = ++startedGeneration.current;
        setRunning(true);
        const response = yield client.generate(payload);
        if (serial < startedGeneration.current) {
            // A newer version of the prompt has been completed
            // so we should ignore this one
            return;
        }
        if (response.ok) {
            setComponent(response.component);
        }
        setRunning(false);
    }), [prompt, generator, schema, actions, instructions, flags, client]);
    const debounceTimeout = useRef(null);
    useEffect(() => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }
        debounceTimeout.current = window.setTimeout(() => {
            log("generating", { prompt, schema, generator, endpoint });
            void generate();
        }, promptDebounceDelay);
        return () => {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
        };
    }, [prompt, generate, schema, generator, endpoint]);
    if (prompt.trim() === "" || component === undefined)
        return _jsx(EmptyPlaceholder, {});
    return (_jsx(CustomComponentView, Object.assign({}, props, { isRunning: isRunning, component: component.id })));
}
